{
    "data": [
        {
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "date": "2026-03-17T12:00:00Z",
            "date_change": false,
            "active": true,
            "person_id": "bff74e85-7c4d-4b33-b177-a619e9ddb97c",
            "visit_summary": "Se visitó las instalaciones de la empresa, se tomó evidencia fotográfica de la entrada, se habló con el personal de recepción.",
            "will_visit_prospect": false,
            "visitor_id": null,
            "created_at": "2026-03-23T21:44:25.763347",
            "updated_at": "2026-03-23T21:44:25.763394",
            "id": "5c17f5e3-71a9-4924-b29e-a259a305914f"
        }
    ]
}
